import { type QueryClient, type QueryKey } from '@tanstack/react-query'

export const invalidateQueryKeys = async (
  queryClient: QueryClient,
  queryKeys: readonly QueryKey[]
) => {
  await Promise.all(
    queryKeys.map(async (queryKey) => {
      await queryClient.invalidateQueries({
        queryKey,
        exact: true,
      })
    })
  )
}
